import React, { Fragment, useState, useCallback, useEffect } from 'react';
import styled from 'styled-components';

import { SmallToggleSwitch } from '../../../../../../components/ToggleSwitch/ToggleSwitch';

const ToggleWrapper = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-gap: 28px;
  align-items: center;
`;

let ProductFeaturedFormComponent = ({
  disabled,
  is_featured,
  patchProductIsFeatured,
}) => {
  return (
    <ToggleWrapper>
      <SmallToggleSwitch
        disabled={false}
        checked={is_featured}
        onChange={(e) => patchProductIsFeatured(e.target.checked)}
      />
      <div>
        {is_featured
          ? `Use the toggle to unmark a product as 'Featured'.`
          : `Use the toggle to mark a product as 'Featured' and visually highlight it for customers.`}
      </div>
    </ToggleWrapper>
  );
};

// const mapStateToProps = (state) => {

export default ProductFeaturedFormComponent;
